export const CHANNELWILL_APP_ID = '518111167165104128'
